module.exports = __webpack_public_path__ + "c061342efc63363d334e683f3d963a75.pdf";